import { Link } from 'react-router-dom';
import SystemTerminal from './SystemTerminal';

function Hero() {
  return (
    <section id="top" className="relative pt-[76px] overflow-hidden">
      <div className="absolute -top-24 right-[-10%] w-[560px] h-[560px] rounded-full bg-accent-200/40 blur-3xl pointer-events-none"></div>

      <div className="relative w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-[45fr_55fr] gap-12 lg:gap-14 items-center max-w-[1440px] mx-auto">
          {/* left copy */}
          <div className="w-full">
            <div className="inline-flex items-center gap-2 px-3 h-8 rounded-full border border-primary-300 bg-primary-50 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              <span className="text-[11px] font-data tracking-[0.18em] text-primary-700">
                XAUUSD · MT5 EXPERT ADVISOR
              </span>
            </div>

            <h1 className="font-heading font-extrabold text-foreground-950 tracking-tight text-[42px] leading-[1.04] sm:text-[56px] lg:text-[68px] xl:text-[74px]">
              Gold Trading, <br className="hidden sm:block" />
              Systematized.
            </h1>

            <p className="mt-6 font-heading font-semibold text-foreground-700 text-lg md:text-xl">
              Built around XAUUSD. Executed through MT5.
            </p>

            <p className="mt-5 text-[15px] md:text-base leading-relaxed text-foreground-600 max-w-[500px]">
              A systematic Expert Advisor focused exclusively on gold, combining structured
              trade decisions with automated execution and transparent trade records.
            </p>

            <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#process"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-[15px] font-semibold whitespace-nowrap transition-all duration-200 cursor-pointer hover:-translate-y-0.5"
              >
                Explore How It Works
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
              <Link
                to="/trade-journal"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-foreground-300 text-foreground-950 text-[15px] font-semibold whitespace-nowrap hover:border-primary-400 hover:text-primary-700 transition-all duration-200 cursor-pointer hover:-translate-y-0.5"
              >
                View Trade Journal
              </Link>
            </div>

            <div className="mt-9 flex items-center gap-5 text-[12px] font-data tracking-wider text-foreground-500">
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-checkbox-blank-circle-fill text-[6px] text-primary-500"></i>
                </span>
                SYSTEMATIC
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-checkbox-blank-circle-fill text-[6px] text-primary-500"></i>
                </span>
                RULE-BASED
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-checkbox-blank-circle-fill text-[6px] text-primary-500"></i>
                </span>
                TRANSPARENT
              </span>
            </div>
          </div>

          {/* right terminal */}
          <div className="w-full">
            <div className="mb-3 flex items-center justify-between">
              <span className="text-[11px] font-data tracking-[0.2em] text-foreground-500">
                XAUUSD SYSTEM TERMINAL
              </span>
              <span className="text-[11px] font-data tracking-[0.2em] text-foreground-400">
                REV. 2026.09
              </span>
            </div>
            <SystemTerminal />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;